import type { BusinessNumberState } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { BusinessProfileFields } from '@/entities/user';
import { CheckboxField } from '@/shared/ui';
import type { BankTransferFormErrors, BankTransferFormValues } from '../model/bank-transfer-form';

export const TaxInvoiceFields = ({
  values,
  errors,
  onChange,
  onCheck,
  businessState,
  isChecking,
}: {
  readonly values: BankTransferFormValues;
  readonly errors: BankTransferFormErrors;
  readonly onChange: <K extends keyof BankTransferFormValues>(
    key: K,
    value: BankTransferFormValues[K],
  ) => void;
  readonly onCheck: () => void;
  readonly businessState: BusinessNumberState | null;
  readonly isChecking: boolean;
}): ReactElement => (
  <div className="flex flex-col gap-5">
    <BusinessProfileFields
      values={values}
      errors={errors}
      onChange={onChange}
      onCheck={onCheck}
      businessState={businessState}
      isChecking={isChecking}
    />
    <CheckboxField
      label="이 정보를 사업자 정보에 저장"
      checked={values.saveToProfile}
      onChange={(event) => onChange('saveToProfile', event.target.checked)}
    />
  </div>
);
